import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ApiResponse } from '@card-software/library';
import { Department } from '../models/department-manager/department';

@Injectable({
  providedIn: 'root',
})
export class DepartmentsProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/department`;

  constructor(private httpClient: HttpClient) {}

  getAllDepartments(): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/all`);
  }

  getDepartmentById(id: string): Observable<ApiResponse<Department>> {
    return this.httpClient.get<ApiResponse<Department>>(`${this.baseUrl}/${id}`);
  }

  createDepartment(department: Department): Observable<ApiResponse<Department>> {
    return this.httpClient.post<ApiResponse<Department>>(`${this.baseUrl}`, department);
  }

  updateDepartment(department: Department): Observable<ApiResponse<Department>> {
    return this.httpClient.put<ApiResponse<Department>>(`${this.baseUrl}/${department.id}`, department);
  }

  deleteDepartment(id: string): Observable<ApiResponse<void>> {
    return this.httpClient.delete<ApiResponse<void>>(`${this.baseUrl}/${id}`);
  }

  updateDepartmentMembers(departmentId: string, members: string[]): Observable<ApiResponse<Department>> {
    return this.httpClient.post<ApiResponse<Department>>(`${this.baseUrl}/${departmentId}/update-members`, members);
  }

  updateDepartmentManagers(departmentId: string, managers: string[]): Observable<ApiResponse<Department>> {
    return this.httpClient.post<ApiResponse<Department>>(`${this.baseUrl}/${departmentId}/update-managers`, managers);
  }

  getDepartmentsByMember(username: string): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/search-by-member?username=${encodeURIComponent(username)}`);
  }

  getDepartmentsByManager(username: string): Observable<ApiResponse<Department[]>> {
    return this.httpClient.get<ApiResponse<Department[]>>(`${this.baseUrl}/search-by-manager?username=${encodeURIComponent(username)}`);
  }
}
